import React from 'react'
import { EmptyTableView } from '../../Component/EnhancedData/EmptyTableView'

export const buildLineItemEmptyTableView = (onAddProductClick: () => void): React.JSX.Element => {
  const message = 'No product items have been added.'
  return (
    <EmptyTableView message={message}>
      <button className={'strong-anchor add-product-link'} onClick={onAddProductClick}>
        Add or Create a Product Item.
      </button>
    </EmptyTableView>
  )
}
